
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useGlobalState } from '../../../../globalStates/ProfileThemeState';
const HouseBackground = dynamic({
    loader: () => import('../HouseBackground'),
    ssr: false
});
const propTypes = {
    house: PropTypes.oneOf(['gryffindor', 'slytherin', 'hufflepuff', 'ravenclaw']).isRequired
};
const HouseBackgroundOrigin = ({ house }) => {
    const [crestLocation] = useGlobalState('crestLocation');
    if (crestLocation?.x && crestLocation?.y && crestLocation.width && crestLocation.height)
        return <HouseBackground house={house} backgroundOrigin={crestLocation}/>;
    return false;
};
HouseBackgroundOrigin.propTypes = propTypes;
export default HouseBackgroundOrigin;

    async function __Next_Translate__getStaticProps__195ca0e9a40__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//Profile/components/HouseBackgroundOrigin/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0e9a40__ as getStaticProps }
  